import './Button.css'

import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import Loading from '../Loading/Loading'
import { withTracking } from '../ReactGAUtils/ReactGAUtils'

const Button = ({
  children,
  sendEvent,
  disabled,
  loading,
  onClick = () => {},
  responsive = false,
  style = 'link',
  type = 'button',
  ...props
}) => {
  const clickHandler = event => {
    onClick(event)
    sendEvent()
  }

  const loadingStyle = style.includes('primary') ? 'primary' : 'link'

  return (
    <button
      type={type}
      styleName={cx(style, {loading, responsive})}
      onClick={clickHandler}
      disabled={disabled || loading}
      {...props}
    >
      {loading
        ? <Loading style={loadingStyle} />
        : children
      }
    </button>
  )
}

Button.propTypes = {
  sendEvent: PropTypes.func,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  responsive: PropTypes.bool,
  style: PropTypes.oneOf(['primary', 'link', 'primaryWide', 'linkWide', 'secondary']),
  type: PropTypes.oneOf(['submit', 'button', 'reset'])
}

// Need to set DisplayName so HOC name
// doesn't interfere with tests
const TrackedButton = withTracking(Button)
TrackedButton.displayName = 'Button'

export default TrackedButton
